import {
  BaseReducerState,
  DeleteChallanAPIResponse
} from '../../../services'
import { ActionTypes } from '../actions'

export type DeleteChallanState = BaseReducerState & {
  data: boolean | null
}

export const apiInitialState: DeleteChallanState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const deleteChallan = (
  state: DeleteChallanState = apiInitialState,
  action: { type: string; res: any }
): DeleteChallanState => {
  switch (action.type) {
    case `${ActionTypes.DELETE_CHALLAN}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.DELETE_CHALLAN}_SUCCESS`: {
      const { success, data, message } = <DeleteChallanAPIResponse>action.res
      return {
        ...state,
        loading: false,
        data,
        success,
        message,
      }
    }
    case `${ActionTypes.DELETE_CHALLAN}_FAILURE`:
      const res = <DeleteChallanAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        data:false,
        error,
      }

    case `${ActionTypes.DELETE_CHALLAN}_RESET`:
      return {
        ...apiInitialState,
      }
  }
  return state
}
